module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CX-915eaf6c3cb592b8bf6686e327f0bb30.png";